<template>
  <v-card class="mx-auto" max-width="600">
    <v-card-text>
      <p>Welcome to an EVE Online ship info and fittings tool.</p>
      <p>
        This tool is entirely run at the client level (your computer), and no
        information about your character or fittings is stored anywhere but on
        your own system. If at any time you wish to clear your information,
        click the CLEAR CACHE button in the page footer.
      </p>
    </v-card-text>
    <v-card-actions>
      <v-btn :to="{ name: 'Ships' }" color="light-blue darken-4">
        Ships
      </v-btn>
      <v-btn :to="{ name: 'Fittings' }" color="deep-purple darken-1">
        Fittings
      </v-btn>
      <v-btn :to="{ name: 'Character' }" color="deep-orange darken-3">
        Character
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "Home"
};
</script>
